import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const h = r((s, e) => /* @__PURE__ */ c.jsx(
  l,
  {
    ref: e,
    ...s,
    image: (a) => /* @__PURE__ */ c.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...a,
        children: [
          /* @__PURE__ */ c.jsxs(
            "mask",
            {
              id: "mask0_2974_4168",
              width: 21,
              height: 32,
              x: 14,
              y: 8,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ c.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M24.5 24.12c.41 0 .75-.34.75-.75v-1.1c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.1c0 .42.34.75.75.75M24.51 24.95c-1.51 0-2.74 1.23-2.74 2.74s1.23 2.74 2.74 2.74 2.74-1.23 2.74-2.74c0-1.52-1.23-2.74-2.74-2.74m0 3.97a1.24 1.24 0 1 1 0-2.48 1.24 1.24 0 0 1 0 2.48M24.5 31.24c-.41 0-.75.34-.75.75v1.1c0 .41.34.75.75.75s.75-.34.75-.75v-1.1c0-.41-.34-.75-.75-.75M20.8 25.04c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-.52-.52a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06zM28.23 30.34a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l.5.5c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06zM27.72 25.21c.19 0 .38-.07.53-.22l.47-.47c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-.47.47c-.29.29-.29.77 0 1.06.15.15.34.22.53.22M20.82 30.3l-.54.54c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l.54-.54c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0M20.96 27.68c0-.41-.34-.75-.75-.75h-1.12c-.41 0-.75.34-.75.75s.34.75.75.75h1.13c.41 0 .74-.33.74-.75M29.91 26.93h-1.08c-.41 0-.75.34-.75.75s.34.75.75.75h1.08a.749.749 0 1 0 0-1.5"
                  }
                ),
                /* @__PURE__ */ c.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M32.36 15.37H16.65c-1.46 0-2.65 1.18-2.65 2.64v19.34c0 1.46 1.19 2.65 2.65 2.65h15.71c1.46 0 2.64-1.19 2.64-2.64V18.01c0-1.46-1.19-2.64-2.64-2.64m1.14 21.98c0 .63-.51 1.14-1.14 1.14H16.65c-.63 0-1.15-.51-1.15-1.14V18.01c0-.63.51-1.15 1.15-1.15h15.71c.63 0 1.14.51 1.14 1.15zM20.98 13.69c.41 0 .75-.34.75-.75V9.5h5.53v3.44c0 .41.34.75.75.75s.75-.34.75-.75V8.75c0-.41-.34-.75-.75-.75h-7.03c-.41 0-.75.34-.75.75v4.19c0 .41.34.75.75.75"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ c.jsx("g", { mask: "url(#mask0_2974_4168)", children: /* @__PURE__ */ c.jsx("path", { fill: "currentColor", d: "M.246 0h47.213v48H.246z" }) })
        ]
      }
    )
  }
));
h.displayName = "AgencySunscreenIcon";
export {
  h as AgencySunscreenIcon,
  h as default
};
//# sourceMappingURL=index.js.map
